"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "What are dental implants and how do they work?",
  answer: "Dental implants are permanent replacements for missing teeth. They consist of a medical-grade titanium post that acts as a root, an abutment, and a custom-crafted crown. This structure integrates with your jawbone, providing a stable and natural-feeling solution that prevents bone loss."
}, {
  question: "How long is the recovery process for implants?",
  answer: "Initial healing typically takes about 7 to 10 days, during which any minor discomfort can be managed with standard care. The full process of osseointegration—where the implant bonds with the bone—usually takes 3 to 6 months before the final permanent crown is placed."
}, {
  question: "Are dental implants painful?",
  answer: "Most patients report that the procedure is much more comfortable than they anticipated. At Smart Choice, we specialize in sedation dentistry to ensure you remain completely relaxed. Post-procedure soreness is typically minimal and easily managed with over-the-counter relief."
}, {
  question: "Am I a good candidate for implants or dentures?",
  answer: "Most adults with healthy gums and sufficient jawbone density are excellent candidates for implants. During your free consultation in El Monte, we utilize advanced imaging to evaluate your specific needs and determine if implants, dentures, or a hybrid solution is best for your smile."
}, {
  question: "How do I care for my new dental implants?",
  answer: "Caring for implants is remarkably simple—you treat them just like your natural teeth. Regular brushing, daily flossing, and routine check-ups at our El Monte office are all that's required. Unlike traditional dentures, there's no need for messy adhesives or special cleaning soaks."
}, {
  question: "How long do dental implants typically last?",
  answer: "When properly maintained with good oral hygiene, dental implants are designed to be a lifelong solution. They are highly resistant to decay and are the most durable tooth replacement option available in modern restorative dentistry today."
}, {
  question: "What financing options are available for treatment?",
  answer: "We believe everyone deserves a confident smile. Smart Choice Dentures & Implants offers competitive, transparent pricing and a variety of flexible financing plans. We work with you to find a monthly payment that fits your budget while providing the high-quality care you deserve."
}];
export default function Faq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="177789" id="implant-faqs" className="w-full dark bg-background py-24 md:py-32">
      <div ref={ref} className={`container mx-auto max-w-4xl px-4 transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        <div className="mb-16 text-center">
          <h2 className="mb-6 font-serif text-4xl font-semibold tracking-tight text-foreground md:text-5xl lg:text-6xl">
            Implant & Denture FAQs
          </h2>
          <p className="mx-auto max-w-2xl font-sans text-lg text-muted-foreground md:text-xl">
            Providing clarity and compassionate answers for our El Monte patients. Everything you need to know about restoring your smile with confidence.
          </p>
        </div>

        <div className="mx-auto w-full max-w-3xl">
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="rounded-xl border border-border/40 bg-card/30 px-6 py-2 transition-all duration-300 hover:border-primary/30 data-[state=open]:border-primary/40 data-[state=open]:bg-card/60 data-[state=open]:shadow-lg">
                <AccordionTrigger className="font-serif text-left text-lg font-medium text-foreground transition-colors hover:text-primary hover:no-underline md:text-xl [&[data-state=open]]:text-primary">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="font-sans text-base leading-[1.8] text-muted-foreground md:pr-12 md:text-lg">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}